import { Component } from '@angular/core';

@Component({
  templateUrl: 'public.section.layout.html',
})
export class PublicSectionLayoutComponent {
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/public/public.section.layout.ts